import React from "react";
import { Link } from "react-router-dom";
import { useDrawerShopNav } from "./drawerShopSlot";

// The registered shop navigation, at the top of the ☰ drawer (small screens only, see SideDrawer.css).
// Every entry closes the drawer; links are router links (no reload).
export default function DrawerShopSection({ click }) {
  const nav = useDrawerShopNav();
  if (!nav?.sections?.length) return null;
  return (
    <div className="drawer-shop-section" data-owner={nav.owner}>
      {nav.title && <p className="drawer-shop-section__title">{nav.title}</p>}
      {nav.sections.filter((s) => s.items?.length).map((section) => (
        <div className="drawer-shop-section__group" key={section.key} role="group" aria-label={section.label}>
          <p className="drawer-shop-section__label">{section.label}</p>
          <ul>
            {section.items.map((item) => {
              const Icon = item.icon;
              const body = <>{Icon && <Icon aria-hidden="true" />}<span>{item.label}</span></>;
              return (
                <li key={item.key}>
                  {item.inert
                    ? <span className="drawer-shop-section__item drawer-shop-section__item--inert" aria-disabled="true">{body}</span>
                    : item.to
                      ? <Link className="drawer-shop-section__item" to={item.to} onClick={click}>{body}</Link>
                      : <button type="button" className="drawer-shop-section__item" onClick={() => { click?.(); item.onClick?.(); }}>{body}</button>}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}
